import Tool, { type ToolHandler } from '../Tool';
import type { AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';
import { getReferenceNumFromUrl } from 'javascripts/assistant_context';

/**
 * Handler for Reports::ManageReportTool
 * Handles updating report tables and filters when reports are modified
 */
function refreshReportUI(toolCall: AssistantToolCall): void {
  const referenceNum = getReferenceNumFromUrl(window.location.pathname);
  if (
    referenceNum &&
    referenceNum.startsWith('Report-') &&
    toolCall.content?.panel?.body === referenceNum.split('-')[1]
  ) {
    // Refresh the main report table
    const $table = $('#table-form');
    if ($table.length > 0) {
      const url = $table.attr('data-reactive-url');
      window.reactor?.forceUpdateElement($table, url);
    }

    // Refresh the filters
    const $filters = $('.rendered-filters[data-reactive-url]');
    if ($filters.length > 0) {
      const filtersUrl = $filters.attr('data-reactive-url');
      window.reactor?.forceUpdateElement($filters, filtersUrl);
    }
  }
}

const manageReportToolHandler: ToolHandler = {
  processToolCall(toolCall: AssistantToolCall, agent: Agent): void {
    if (toolCall.status === 'complete') {
      refreshReportUI(toolCall);
    }
  },
};

Tool.register('Reports::ManageReportTool', manageReportToolHandler);
